import { API } from '../axios-instance'
import { Tenant, TenantLoginRedirect } from './types'

// * TENANT

export const listTenants = async (domain: string) => {
  try {
    return await API.get<Tenant[]>('/identity/tenants/my', { params: { domain } }).then(r => r.data)
  } catch (e) {
    try {
      delete API.defaults.headers.common['Authorization']
      window.localStorage.removeItem('session-storage')
      window.location.replace('/')
    } catch {
      /* noop */
    }
    throw e
  }
}

export const initiateTenantLogin = async ({ tenantId }: { tenantId: string }) => {
  return await API.post<TenantLoginRedirect>(`/identity/tenants/${tenantId}/login`, undefined, {
    withCredentials: true,
  }).then(r => r.data)
}
